export default __webpack_public_path__ + "static/media/res-logo.2f9021c4.png";